<mat-sidenav-container>
    <mat-sidenav></mat-sidenav>
    <mat-sidenav-content>

        <lomas-public-toolbar></lomas-public-toolbar>

        <section>
            <mat-card>
                <mat-card-title>Inschrijven nieuwsbrief</mat-card-title>
                <mat-divider></mat-divider>
                <mat-card-content>
                    <form (submit)="submit()" [formGroup]="createAccountForm" *ngIf="status === 'new'">
                        <p>
                            <mat-form-field class="full-width" color="accent">
                                <input matInput formControlName="firstName" placeholder="Voornaam"/>
                            </mat-form-field>
                            <mat-form-field  class="full-width" color="accent">
                                <input matInput formControlName="email" placeholder="Email"/>
                                <mat-error *ngIf="email.invalid && email.errors.required">Dit veld is verplicht</mat-error>
                                <mat-error *ngIf="email.invalid && email.errors.email">Vul een correct e-mailadres in</mat-error>
                            </mat-form-field>
                        </p>
                        <button mat-raised-button color="primary" type="submit" [disabled]="createAccountForm.invalid" >
                            Versturen
                        </button>

                    </form>
                    <div *ngIf="status !== 'new'" class="result">
                        <p *ngIf="status === 'success'">
                            Uw account is aangemaakt. Er is een email gestuurd waarmee u uw inschrijving kunt bevestigen.
                        </p>
                        <p *ngIf="status === 'exists'">
                            Er bestaat al een account met dit e-mailadres. <a [routerLink]="['/login']" [queryParamsHandling]="'merge'">Login</a>
                        </p>
                        <p *ngIf="status === 'fail'">
                            Er is iets misgegaan met het aanmaken van uw inschrijving.
                        </p>
                    </div>
                </mat-card-content>
            </mat-card>
        </section>
    </mat-sidenav-content>
</mat-sidenav-container>

